import { Component, OnInit, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import moment from "moment";
import { take } from "rxjs/operators";

import { AuthenticationService } from "src/app/services/authentication.service";
import { TextoService } from "src/app/services/texto.service";
import { HelperService } from "src/app/services/helper.service";
import { SpinnerService } from "src/app/services/spinner.service";
import { PdfMakeService } from "src/app/services/pdfmake.service";
import { BeneficiarioService } from "src/app/services/beneficiario.service";
import { EventEmitterService } from "src/app/services/event-emitter.service";

import { Beneficiario } from "src/app/types/Beneficiario";
import { DadosBeneficiario } from "src/app/types/DadosBeneficiarios";
import { User } from "src/app/types/User";
import { Router } from "@angular/router";

@Component({
  selector: "app-page-confidencialidade",
  templateUrl: "./page-aceite-confidencialidade.component.html",
  styleUrls: ["./page-aceite-confidencialidade.component.scss"],
  host: { class: "full-width" },
})
export class PageAceiteConfidencialidadeComponent implements OnInit {
  termoDeConfidencialidade = "";
  termoDeConfidencialidadeBenef = "";
  aceiteCondicoes = false;

  ip: string = "";
  beneficiarios?: Beneficiario;
  beneficiario?: DadosBeneficiario;
  currentUser?: User;

  mostrarSpin = false;
  hoje = moment().locale("pt-br").format("LL");
  horario = moment().format("LT");

  cpf = "";
  dataNascimento = "";

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public authenticationService: AuthenticationService,
    private textoService: TextoService,
    private helperService: HelperService,
    private pdfMakeService: PdfMakeService,
    private beneficiarioService: BeneficiarioService,
  ) {
    // this.subscribeUser();
    this.subscribeSpinner();
  }

  ngOnInit() {
    this.initializeTexts();

    if (this.isBeneficiario()) {
      this.loadBeneficiario();
    }
  }

  /**  Inicializa os textos fixos */
  private initializeTexts() {
    this.termoDeConfidencialidade = this.textoService.TermoDeConfidencialidade;
    this.termoDeConfidencialidadeBenef =
      this.textoService.TermoDeConfidencialidadeBeneficiario;
  }

  /**  Observa o evento global de loading */
  private subscribeSpinner() {
    EventEmitterService.get("AlteraLoading").subscribe((status: boolean) => {
      this.mostrarSpin = status;
    });
  }

  /**  Verifica se o usuário é beneficiário */
  private isBeneficiario(): boolean {
    return this.authenticationService.currentUserValue.tipoUsuarioId === 1;
  }

  /**  Carrega dados do beneficiário logado */
  private loadBeneficiario() {
    this.beneficiarioService
      .consultaDadosBeneficiarioToken()
      .pipe(take(1))
      .subscribe((benef: DadosBeneficiario) => {
        this.beneficiario = benef;
        this.cpf = this.helperService.formataCPF(benef.cpf);
        this.dataNascimento = moment(benef.dataNascimento).format("DD/MM/YYYY");

        this.authenticationService.updateCurrentUser({
          ...this.authenticationService.currentUserValue,
          existeTermo: benef.existeTermo,
          situacaoPep: benef.situacaoPep,
        });
      });
  }

  async processarDocumento(aprovado: boolean) {
    this.mostrarSpin = true;

    setTimeout(() => {
      this.mostrarSpin = false;
    }, 5000);

    try {
      const dadosDocumento = this.getDocumentData();
      await this.enviarPDF(dadosDocumento, aprovado);
    } catch (err) {
      console.error(
        `Erro ao ${aprovado ? "salvar" : "negar"} o documento:`,
        err
      );
    }
  }

  async salvar() {
    await this.processarDocumento(true);
  }

  async negar() {
    await this.processarDocumento(false);
  }




  /** Lê dados de elementos no DOM */
  private getDocumentData() {
    const get = (selector: string) =>
      (this.document.querySelector(selector) as HTMLElement)?.innerText ?? "";

    return {
      subtitulo: get(".subtitulo"),
      dadosBenef: get(".dadosBeneficiario"),
      termo: get(".termsx"),
      assinante: get(".name-assinante"),
      dataAssinada: get(".dataAssinada"),
      tipoAssinatura: get(".tipo-assinatura"),
      identification: get(".identification"),
      dataExecucao: get(".campo-data"),
      footer: get(".footer"),
    };
  }



  /** Envia o PDF para geração */
  private async enviarPDF(dados, autorizacao) {
    try {
      await this.pdfMakeService.generatePdf(
        dados.subtitulo,
        this.textoService.termoVerificarSituacao(autorizacao),
        dados.assinante,
        dados.dataAssinada,
        dados.tipoAssinatura,
        dados.identification,
        dados.footer,
        dados.dadosBenef,
        dados.dataExecucao,
        autorizacao
      );
    } catch (error) {
      console.error(error);
    } finally {
    }
  }

  /**  Encerramento do fluxo com redirecionamento */
}
